export const handleScoringDateType = (obj) => {
    if (obj?.filterBy === 'event_date') {
        if (obj.flag === 'month') {
            return 'event_date__month'
        }
        if (obj.flag === 'week') {
            return 'event_date__week'
        }
        if (obj.flag === 'quarter') {
            return 'event_date__quarter'
        }
    } else if (obj?.filterBy === "created_at") {
        if (obj.flag === 'month') {
            return 'created_at__month'
        }
        if (obj.flag === 'week') {
            return 'created_at__week'
        }
        if (obj.flag === 'quarter') {
            return 'created_at__quarter'
        }
    } else if (obj?.filterBy === 'updated_at') {
        if (obj.flag === 'month') {
            return 'updated_at__month'
        }
        if (obj.flag === 'week') {
            return 'updated_at__week'
        }
        if (obj.flag === 'quarter') {
            return 'updated_at__quarter'
        }
    }
}

export const getScoringDateType = (obj) => {
    if (obj?.filterBy === 'event_date') {
        if (obj.flag === 'month') {
            return obj?.eventDateMonth
        }
        if (obj.flag === 'week') {
            return obj?.eventDateWeek
        }
        if (obj.flag === 'quarter') {
            return obj?.eventDateQuarter
        }
    } else if (obj?.filterBy === 'created_at') {
        if (obj.flag === 'month') {
            return obj?.createdAtMonth
        }
        if (obj.flag === 'week') {
            return obj?.createdAtWeek
        }
        if (obj.flag === 'quarter') {
            return obj?.createdAtQuarter
        }
    } else if (obj?.filterBy === 'updated_at') {
        if (obj.flag === 'month') {
            return obj?.updatedAtMonth
        }
        if (obj.flag === 'week') {
            return obj?.updatedAtWeek
        }
        if (obj.flag === "quarter") {
            return obj?.updatedAtQuarter
        }
    }
}

export const handleDateTypeYear = (item) => {
    if (item?.filterBy === 'created_at') {
        return "created_at__year"
    }
    if (item?.filterBy === 'event_date') {
        return "event_date__year"
    }
    if (item?.filterBy === 'updated_at') {
        return "updated_at__year"
    }
}
export const getDateTypeYear = (item) => {
    if (item?.filterBy === 'created_at') {
        return item?.createdAtYear
    }
    if (item?.filterBy === 'event_date') {
        return item?.eventDateYear
    }
    if (item?.filterBy === 'updated_at') {
        return item?.updatedAtYear
    }
}